import React from 'react'

import PropTypes from 'prop-types'

import { EscapeKeyPressed } from 'utils/DOMEvents'

import { BoxSummaryBanner } from './Banner/BoxSummaryBanner'
import { BoxSummaryOverlayContainer } from './BoxSummaryOverlay/BoxSummaryOverlayContainer'
import { CheckoutErrorModal } from './CheckooutErrorModal/CheckoutErrorModal'

import css from './BoxSummary.css'

export class BoxSummary extends React.PureComponent {
  // eslint-disable-next-line react/static-property-placement
  static propTypes = {
    isMobile: PropTypes.bool.isRequired,
    showDetails: PropTypes.bool.isRequired,
    boxDetailsVisibilityChange: PropTypes.func.isRequired,
    basketIsPortionSizeViewVisibleChange: PropTypes.func.isRequired,
    basketRestorePreviousValues: PropTypes.func.isRequired,
    hasUnavailableRecipes: PropTypes.bool,
    orderSaveError: PropTypes.string,
    pricingPending: PropTypes.bool,
    shouldShowBoxSummary: PropTypes.bool,
    totalPrice: PropTypes.string,
    isAuthenticated: PropTypes.bool.isRequired,
    detailsSurface: PropTypes.node,
  }

  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    shouldShowBoxSummary: false,
    hasUnavailableRecipes: false,
    orderSaveError: null,
    pricingPending: false,
    totalPrice: null,
    detailsSurface: null,
  }

  componentDidMount() {
    const {
      hasUnavailableRecipes,
      orderSaveError,
      boxDetailsVisibilityChange,
      shouldShowBoxSummary,
    } = this.props

    window.document.addEventListener('click', this.handleClick, false)

    if ((hasUnavailableRecipes && orderSaveError === 'no-stock') || shouldShowBoxSummary) {
      boxDetailsVisibilityChange(true)
    }
  }

  componentWillUnmount() {
    const { boxDetailsVisibilityChange } = this.props

    window.document.removeEventListener('click', this.handleClick, false)

    boxDetailsVisibilityChange(false)
  }

  handleClick = (e) => {
    const { showDetails } = this.props
    if (showDetails && EscapeKeyPressed(e)) {
      this.close()
    }
  }

  handleError() {
    const { orderSaveError } = this.props
    const hadOrderSaveError = Boolean(orderSaveError) && orderSaveError !== 'no-stock'
    const stockError =
      typeof orderSaveError === 'string' &&
      orderSaveError.includes('following recipes are sold-out')
        ? orderSaveError
        : undefined
    const basketExpiredError = orderSaveError === 'basket-expired'
    const basketExpiredMessage = basketExpiredError
      ? 'Sorry, your box has expired. Please re-add your recipe choices to continue'
      : undefined

    return {
      showErrorModalPopup: hadOrderSaveError,
      customMessage: basketExpiredMessage || stockError,
      stockError,
    }
  }

  open = () => {
    const { boxDetailsVisibilityChange, totalPrice } = this.props
    boxDetailsVisibilityChange(true, totalPrice)
  }

  close = () => {
    const {
      boxDetailsVisibilityChange,
      basketRestorePreviousValues,
      basketIsPortionSizeViewVisibleChange,
    } = this.props
    basketIsPortionSizeViewVisibleChange(false)
    boxDetailsVisibilityChange(false)
    basketRestorePreviousValues()

    // Return focus to the desktop trigger when the overlay is dismissed.
    setTimeout(() => {
      const expandBoxSummaryButton = document.querySelector(
        '[data-testing="expandBoxSummaryButton"]',
      )
      if (expandBoxSummaryButton instanceof HTMLElement) {
        expandBoxSummaryButton.focus()
      }
    }, 0)
  }

  toggle = () => {
    const { showDetails, pricingPending } = this.props
    const show = !showDetails && !pricingPending

    if (show) {
      this.open()
    } else {
      this.close()
    }
  }

  render() {
    const { showDetails, isMobile, isAuthenticated, detailsSurface } = this.props
    const { customMessage, showErrorModalPopup } = this.handleError()

    return (
      <div className={css.boxSummary} data-testing="boxSummary">
        <CheckoutErrorModal
          customMessage={customMessage}
          shouldShow={showErrorModalPopup}
          isAuthenticated={isAuthenticated}
        />

        <BoxSummaryBanner />
        {detailsSurface || (
          <BoxSummaryOverlayContainer
            isMobile={isMobile}
            onCloseClick={this.close}
            onToggleVisibility={this.toggle}
            showDetails={showDetails}
          />
        )}
      </div>
    )
  }
}
